module.exports = "/_next/static/images/bri-icon-a91f28adfb9877357b0f4e72f19529d0.svg";